import React, { memo } from 'react';
import styled from 'styled-components';
import SwimlaneShimmer from '@shopDetails/components/Shimmer/SwimlaneShimmer';
import SectionTitle from '@shopDetails/components/Shimmer/Title';
import ProductCardShimmer from './ProductCardShimmer';

const Container = styled.div`
  margin: ${({ theme }) => theme.spacing(8)};
`;

const cards = [1, 2, 3];

const ProductListShimmer = () => (
  <>
    <SwimlaneShimmer isDesktopLayout={false} />
    <Container aria-busy="true">
      <SectionTitle />
      {cards.map(card => (
        <ProductCardShimmer id={card} key={card} />
      ))}
    </Container>
  </>
);

export default memo(ProductListShimmer);
